import React, { PropTypes } from "react";
import CpdRecordedItem from "components/CpdLocker/CpdRecordedItem";
import { connect } from "react-redux";
import { push } from "redux-router";
import actions from "actions";
import constants from "constants";
import storage from "services/storage.js";
import moment from "moment";
import { Link } from "react-router";

const { RECORDED_WEBINARS, MODAL_TYPE_QUIZ } = constants;

const { loadUsersWebinarsSaga, cleanUsersWebinars, showModal, getStudygroups } =
  actions;

class CpdUserRecorded extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      activeYear: new Date().getFullYear(),
      group_id: "",
    };
  }
  onItemClick = ({ audio_link, group_id, id }) => {
    if (group_id && audio_link) {
      this.props.dispatch(push(`/groups/${group_id}/webinars/${id}/audio`));
      return;
    }
    if (group_id) {
      this.props.dispatch(push(`/groups/${group_id}/webinars/${id}`));
      return;
    }

    this.props.dispatch(push(`/webinars/${id}`));
  };

  componentWillMount() {
    this.props.loadStudygroups({ per_page: 500 });
    this.props.loadWebinars(
      this.state.page,
      this.state.activeYear,
      this.state.group_id
    );
  }

  nextPage = () => {
    this.setState(
      {
        ...this.state,
        page: this.state.page + 1,
      },
      () => {
        this.props.loadWebinars(
          this.state.page,
          this.state.activeYear,
          this.state.group_id
        );
      }
    );
  };

  onYearClick = (year) => {
    this.setState({
      page: 1,
      activeYear: year,
    });
    this.props.loadWebinars(1, year, this.state.group_id);
  };

  componentWillUnmount() {
    this.props.cleanWebinars();
  }

  showQuizModal = (webinar) => {
    this.props.showQuizModal({
      webinar: webinar,
    });
  };

  handleGroupChange = (group_id) => {
    const newYear = new Date().getFullYear();
    const newPage = 1;

    // Always load webinars, regardless of state changes
    this.props.loadWebinars(newPage, newYear, group_id);

    // Update state for UI
    this.setState({
      group_id,
      page: newPage,
      activeYear: newYear,
    });
  };

  render() {
    const token = storage.getSessionData().session.token;
    const { int_cpds, ext_cpds, from, to } = this.props.cpds || {};

    const { studygroups } = this.props;

    return (
      <div id="recorded" className="main_live col s12">
        <div className="cpd-group-filters">
          <button
            className={`button_classic-years ${
              this.state.group_id === "" ? "active" : ""
            }`}
            onClick={() => this.handleGroupChange("")}
          >
            Medcafe
          </button>
          {studygroups.map(({ id, title }) => (
            <button
              key={id}
              onClick={() => this.handleGroupChange(id)}
              className={`button_classic-years ${
                this.state.group_id === id ? "active" : ""
              }`}
            >
              {title}
            </button>
          ))}
        </div>
        <div className="container_tabs">
          <ul className="tabs cpd_tabs">
            <li className="tab col s2">
              <Link to="/cpd/live">Webinars Attended - Live</Link>
            </li>
            <li className="tab col s2">
              <Link className="active" to="/cpd/recorded">
                Webinars Viewed - Recorded
              </Link>
            </li>
          </ul>
        </div>
        <div className="cpd-years">
          {this.props.years.map((year) => (
            <button
              className={`button_classic-years ${
                this.state.activeYear === year ? "active" : ""
              }`}
              onClick={() => this.onYearClick(year)}
            >
              {year}
            </button>
          ))}
        </div>
        <p className="live_total">
          {from &&
            to &&
            `CPD Year: ${moment(from).format("MMMM YY")} – ${moment(to).format(
              "MMMM YY"
            )}`}
          <br />
          {ext_cpds && <span>{`Ext CPD Points Total: ${ext_cpds}`}</span>}
          {ext_cpds && <br />}
          {int_cpds && <span>Int CPD Points Total: {int_cpds}</span>}
        </p>
        <div className="container_live">
          {this.props.webinars.map((webinar) => (
            <CpdRecordedItem
              webinar={webinar}
              token={token}
              onClick={() => this.onItemClick(webinar)}
              takeCpdQuiz={this.showQuizModal}
            />
          ))}
        </div>
        {this.props.pages > this.state.page && (
          <a
            className="more_item"
            href="javascript:void(0)"
            onClick={this.nextPage}
          >
            LOAD MORE
          </a>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  webinars: state.webinars.usersWebinars[RECORDED_WEBINARS].values,
  cpds: state.webinars.usersWebinars[RECORDED_WEBINARS].cpds,
  pages: state.webinars.usersWebinars[RECORDED_WEBINARS].pages,
  years: state.webinars.usersWebinars[RECORDED_WEBINARS].years || [],
  studygroups: state.studygroups.studygroups.values,
});

const mapDispatchToProps = (dispatch) => ({
  loadWebinars: (page, year, group_id) =>
    dispatch(loadUsersWebinarsSaga(RECORDED_WEBINARS, page, year, group_id)),
  dispatch: dispatch,
  cleanWebinars: () => dispatch(cleanUsersWebinars()),
  showQuizModal: (contentProps) =>
    dispatch(showModal(MODAL_TYPE_QUIZ, contentProps)),
  loadStudygroups: (page, query) => dispatch(getStudygroups(page, query)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CpdUserRecorded);



// WEBPACK FOOTER //
// ./src/containers/CpdUser/CpdUserRecorded.jsx